import { render, staticRenderFns } from "./ProductOrderList.vue?vue&type=template&id=09544d57"
import script from "./ProductOrderList.vue?vue&type=script&lang=js"
export * from "./ProductOrderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports